export const UPDATE_COUNSELLOR = "UPDATE_COUNSELLOR"
export const DELETE_BAD_FIT_ITEM = "DELETE_BAD_FIT_ITEM"
export const UPDATE_BAD_FIT_ITEM = "UPDATE_BAD_FIT_ITEM"
export const DELETE_TASK = "DELETE_TASK"
export const FETCH_ADMIN_DATA = "FETCH_ADMIN_DATA"
export const FETCH_BAD_FIT = "FETCH_BAD_FIT"
export const FETCH_TASK_LIST = "FETCH_TASK_LIST"
export const FETCH_COUNSELLOR_CLIENTS = "FETCH_COUNSELLOR_CLIENTS"
export const FETCH_SOURCES = "FETCH_SOURCES"